<div class="confirm-action-dialog light-content-panel double-margin-top flex-left-column light-control-host">
  <h3 class="panel-title">{{ action }} {{ name }}</h3>
  <ng-content></ng-content>
  <div class="error margin-top">This is a permanent action that cannot be undone.</div>
  <form [formGroup]="confirmActionFormModel" class="flex-center-column full-width" (ngSubmit)="onActionClick()">
    <div *ngIf="error === null" class="margin-top flex-center-row full-width">
      <div>To acknowledge, type "I understand":</div>
      <input
        id="action-confirmation"
        formControlName="confirmation"
        class="margin-left arpio-input spacer"
        focus-element
      />
    </div>
    <div *ngIf="error != null" class="margin-top full-width">
      <h4>Unable to {{ action }} {{ name }}</h4>
      <div class="error">{{ error }}</div>
    </div>
    <div class="flex-center-row margin-top full-width">
      <div class="spacer"></div>
      <button class="arpio-secondary-button" (click)="onCancelClick()" type="button">CANCEL</button>
      <p-button
        pRipple
        [loading]="busy"
        severity="danger"
        type="submit"
        [disabled]="!actionEnabled"
        class="margin-left"
        [label]="actionButtonText"
      ></p-button>
      <div class="spacer"></div>
    </div>
  </form>
</div>
